// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile_upload__6oHr0{
    background-color: black;  
    opacity: 0.8; 
   }
   .profile_profile__5tZNC {
       position: relative;
       display: flex;
       justify-content: center;
     }

     @media (min-width: 600px) {
       .profile_profile__5tZNC {
         justify-content: flex-start;
       }
     }

     @media (min-width: 900px) {
       .profile_profile__5tZNC {
         margin-top: -50%;
       }
     }
     
     .profile_image__BqGct {
      width:160px;
      height: 160px;
      background-color: white;

     }
     
     .profile_middle__BnRX7 {
       transition: .5s ease;
       opacity: 0;
       position: absolute;
       background-color: black;
       width:160px;
       height: 160px;
       top: 50%;
       left: 50%;
       transform: translate(-50%, -50%);
       -ms-transform: translate(-50%, -50%);
       text-align: center;
     }
     
     .profile_profile__5tZNC:hover .profile_image__BqGct {
       opacity: 0.3;
     }
     
     .profile_profile__5tZNC:hover .profile_middle__BnRX7 {
       opacity: 0.7;
     }`, "",{"version":3,"sources":["webpack://./src/views/admin/profile.module.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,YAAY;GACb;GACA;OACI,kBAAkB;OAClB,aAAa;OACb,uBAAuB;KACzB;;KAEA;OACE;SACE,2BAA2B;OAC7B;KACF;;KAEA;OACE;SACE,gBAAgB;OAClB;KACF;;KAEA;MACC,WAAW;MACX,aAAa;MACb,uBAAuB;;KAExB;;KAEA;OACE,oBAAoB;OACpB,UAAU;OACV,kBAAkB;OAClB,uBAAuB;OACvB,WAAW;OACX,aAAa;OACb,QAAQ;OACR,SAAS;OACT,gCAAgC;OAChC,oCAAoC;OACpC,kBAAkB;KACpB;;KAEA;OACE,YAAY;KACd;;KAEA;OACE,YAAY;KACd","sourcesContent":[".upload{\n    background-color: black;  \n    opacity: 0.8; \n   }\n   .profile {\n       position: relative;\n       display: flex;\n       justify-content: center;\n     }\n\n     @media (min-width: 600px) {\n       .profile {\n         justify-content: flex-start;\n       }\n     }\n\n     @media (min-width: 900px) {\n       .profile {\n         margin-top: -50%;\n       }\n     }\n     \n     .image {\n      width:160px;\n      height: 160px;\n      background-color: white;\n\n     }\n     \n     .middle {\n       transition: .5s ease;\n       opacity: 0;\n       position: absolute;\n       background-color: black;\n       width:160px;\n       height: 160px;\n       top: 50%;\n       left: 50%;\n       transform: translate(-50%, -50%);\n       -ms-transform: translate(-50%, -50%);\n       text-align: center;\n     }\n     \n     .profile:hover .image {\n       opacity: 0.3;\n     }\n     \n     .profile:hover .middle {\n       opacity: 0.7;\n     }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"upload": `profile_upload__6oHr0`,
	"profile": `profile_profile__5tZNC`,
	"image": `profile_image__BqGct`,
	"middle": `profile_middle__BnRX7`
};
export default ___CSS_LOADER_EXPORT___;
